export class SimpINControlNames {
  public static capaciteExercice: string = '_SepSep_Initial_SepSep_TypeProcFNS_SepAtt_capaciteExercice';
  public static capaciteEcoFin: string = '_SepSep_Initial_SepSep_TypeProcFNS_SepAtt_capaciteEcoFin';
  public static capaciteTech: string = '_SepSep_Initial_SepSep_TypeProcFNS_SepAtt_capaciteTech';
  public static categorieAcheteur: string = '_SepSep_Initial_SepSep_TypeProcFNS_SepAtt_categorieAcheteur';
  public static accordCadre: string = '_SepSep_Initial_SepSep_TypeProcFNS_SepSep_TechAchatFNS_SepAtt_accordCadre';
  public static criteresAttrib: string = '_SepSep_Initial_SepSep_TypeProcFNS_SepAtt_criteresAttrib';
  public static dateReceptionOffres: string = '_SepSep_Initial_SepSep_TypeProcFNS_SepAtt_dateReceptionOffres';
  public static valeur: string = '_SepSep_Initial_SepSep_TypeFNSSimpleDescMarche_SepSep_TypeMontantFourchette2_SepAtt_valeur';
  public static fourchetteBasse: string = '_SepSep_Initial_SepSep_TypeFNSSimpleDescMarche_SepSep_TypeMontantFourchette2_SepSep_Fourchette_SepAtt_valeurBasse';
  public static fourchetteHaute: string = '_SepSep_Initial_SepSep_TypeFNSSimpleDescMarche_SepSep_TypeMontantFourchette2_SepSep_Fourchette_SepAtt_valeurHaute';


  public static getCtrl_1120Names_json(): any {
    return {
      firstChamp: SimpINControlNames.capaciteExercice,
      secondChamp: SimpINControlNames.capaciteEcoFin,
      thirdChamp: SimpINControlNames.capaciteTech
    }
  }

  public static getCtrl_1086Names_json(): any {
    return {
      firstChamp: SimpINControlNames.categorieAcheteur,
      secondChamp: SimpINControlNames.accordCadre
    }
  }

  public static getCtrl_1087Names_json(): any {
    return {
      firstChamp: SimpINControlNames.criteresAttrib,
      secondChamp: SimpINControlNames.accordCadre
    }
  }

  public static getCtrl_DATENames_json(): any {
    return {firstChamp: SimpINControlNames.dateReceptionOffres}
  }

  public static getCtrl_416Names_json(): any {
    return {firstChamp: SimpINControlNames.dateReceptionOffres}
  }

  public static getCtrl_494Names_json(): any {
    return {
      firstChamp: SimpINControlNames.fourchetteBasse,
      secondChamp: SimpINControlNames.fourchetteHaute
    }
  }

  public static getCtrl_495Names_json(): any {
    return {
      firstChamp: SimpINControlNames.valeur,
      secondChamp: SimpINControlNames.fourchetteBasse,
      thirdChamp: SimpINControlNames.fourchetteHaute
    }
  }

  public static getCtrl_496Names_json(): any {
    return {
      firstChamp: SimpINControlNames.fourchetteBasse,
      secondChamp: SimpINControlNames.fourchetteHaute
    }
  }

  public static getCtrl_2003_1Names_json(index): any {
    return {
      firstChamp: '_SepSep_Initial_SepSep_TypeLotsFNSSimple_index_'+index +'_SepSep_Lot_SepSep_TypeMontant_SepAtt_valeur',
      secondChamp: '_SepSep_Initial_SepSep_TypeLotsFNSSimple_index_'+index+'_SepSep_Lot_SepSep_TypeMontant_SepAtt_devise'
    }
  }

  public static getCtrl_2003_2Names_json(index): any {
    return {
      firstChamp: '_SepSep_Initial_SepSep_TypeLotsFNSSimple_index_'+index+'_SepSep_Lot_SepSep_TypeMontant_SepAtt_devise',
      secondChamp: '_SepSep_Initial_SepSep_TypeLotsFNSSimple_index_'+index +'_SepSep_Lot_SepSep_TypeMontant_SepAtt_valeur'
    }
  }

}
